var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGnbIco02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1738 3.18195C11.6977 2.93935 12.3023 2.93935 12.8262 3.18195L20.5113 6.73308C20.8102 6.8702 21 7.16906 21 7.49956C21 7.83006 20.8102 8.12892 20.5113 8.26604L12.8262 11.8172C12.3023 12.0598 11.6977 12.0598 11.1738 11.8172L3.48867 8.26604C3.18984 8.1254 3 7.82655 3 7.49956C3 7.17258 3.18984 6.8702 3.48867 6.73308L11.1738 3.18195ZM18.641 10.3686L20.5113 11.2335C20.8102 11.3706 21 11.6695 21 12C21 12.3305 20.8102 12.6294 20.5113 12.7665L12.8262 16.3176C12.3023 16.5602 11.6977 16.5602 11.1738 16.3176L3.48867 12.7665C3.18984 12.6258 3 12.327 3 12C3 11.673 3.18984 11.3706 3.48867 11.2335L5.35898 10.3686L10.7027 12.8368C11.5254 13.2165 12.4746 13.2165 13.2973 12.8368L18.641 10.3686ZM13.2973 17.3372L18.641 14.869L20.5113 15.734C20.8102 15.8711 21 16.1699 21 16.5004C21 16.8309 20.8102 17.1298 20.5113 17.2669L12.8262 20.818C12.3023 21.0607 11.6977 21.0607 11.1738 20.818L3.48867 17.2669C3.18984 17.1263 3 16.8274 3 16.5004C3 16.1735 3.18984 15.8711 3.48867 15.734L5.35898 14.869L10.7027 17.3372C11.5254 17.717 12.4746 17.717 13.2973 17.3372Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnbIco02);
export default __webpack_public_path__ + "static/media/Gnb_ico_02.1db576a1cf9dfd98a8b29fb6c9b07b9c.svg";
export { ForwardRef as ReactComponent };